export class Vestibular {
  codigo: number;
  ano: number;
  anoSemestre: string;

  id: {
    codigo: number
    ano: string,
  };

  cursosOfertados: {
    codCurso: string,
    descricaoCurso: string,
  }[];

  dataInscricaoIncial: Date;
  dataInscricaoFinal: Date;
  dataLiberacaoCartao: number;
  dataResultados: number;
  dataVestibular: number;

  isEad: boolean;
  isReingresso: boolean;
  linkExterno: string;
  vestibularAberto: boolean;

  sigla: string;
  tipo: string;
  tipoRaw: string;
  titulo: string;
  valorInscricao: number;

  dia: number[];
  indicacaoEad: string;

  gtagName?: string;

  constructor(args) {
    Object.assign(this, args);
  }
}

export class Resultado {
  anoVestibular: number;
  codigo: number;
  codigoHora: string;
  codigoVestibular: number;
  dia: string;
  hora: {
    codigo: string,
    horaInicial: string,
    horaFinal: string,
  };
  indrea: string;
  tipo: string;
  vestibular: any;

  getDiaTimestamp(): number {
    if (this.dia) {
      return new Date(this.dia).getTime();
    } else {
      return 0;
    }
  }

  constructor(args) {
    Object.assign(this, args);
  }
}

export class ResultadoDia {
  campus: string;
  classificacao: number;
  curso: string;
  descricaoVestibular: any;
  diaVestibular: number;
  isAprovado: string;
  nomeAluno: string;
  turno: string;

  constructor(args) {
    Object.assign(this, args);
  }
}

export class OpcaoCurso {
  id: string;
  nome: string;
  campi: {
    id: string,
    nome: string,
    turnos: string[],
  }[];
  valorCurso: number;
  valorCursoDesconto: number;
  descricaoValorCurso: string;
  exibirWeb: string;

  constructor(args) {
    Object.assign(this, args);
  }
}
